import { queryOptions } from '@tanstack/react-query';

import { UserProfile } from '@cast/types';

import { apiClient } from '@cast/infrastructure-api';
import { gtmPushEvent } from '@cast/infrastructure-analytics';

const USER_PROFILE_QUERY_KEY = 'user-profile';

export const getUserProfileQueryKey = (params: { userId?: string }) =>
  [USER_PROFILE_QUERY_KEY, params.userId] as const;

export const getUserProfileQueryOptions = ({
  userId,
}: {
  userId?: string;
} = {}) => {
  return queryOptions<UserProfile>({
    queryKey: getUserProfileQueryKey({ userId }),
    queryFn: async () => {
      const { data } = await apiClient.user.currentUserProfile();
      if (data.firstLogin) {
        const notificationKey = `product-signup-${userId}`;
        if (!localStorage.getItem(notificationKey)) {
          gtmPushEvent(
            'product-signup',
            {
              'user-id': userId!,
              email: data.email!,
              name: data.name!,
            },
            data.email
          );
          localStorage.setItem(notificationKey, 'true');
        }
      }
      return data as UserProfile;
    },
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    enabled: !!userId,
  });
};
